<template>
    <div id="aia_tabmenu">
        <div id="aia_tabmenu_wrapper">
            <div class="aia-tabmenu-item"
                :class="{'aia-tabmenu-item-active': pageName == 'home'}"
                @click="clickMenu('home')">
                <div class="aia-tabmenu-img">
                    <div class="seperate-bar"></div>
                    <template v-if="localeCode == 1033">
                        <img class="img-fluid" v-if="pageName == 'home'" src="@/components/Layout/footer/asset/mass/mass-privilege-active@3x-en.png" />
                        <img class="img-fluid" v-if="pageName != 'home'" src="@/components/Layout/footer/asset/mass/mass-privilege-inactive@3x-en.png" />
                    </template>
                    <template v-else>
                        <img class="img-fluid" v-if="pageName == 'home'" src="@/components/Layout/footer/asset/mass/mass-privilege-active@3x.png" />
                        <img class="img-fluid" v-if="pageName != 'home'" src="@/components/Layout/footer/asset/mass/mass-privilege-inactive@3x.png" />
                    </template>
                </div>
            </div>
            <div class="aia-tabmenu-item"
                :class="{'aia-tabmenu-item-active': pageName == 'history'}"
                @click="clickMenu('history')">
                <div class="aia-tabmenu-img">
                    <div class="seperate-bar"></div>
                    <template v-if="localeCode == 1033">
                        <img class="img-fluid" v-if="pageName == 'history'" src="@/components/Layout/footer/asset/mass/mass-coupon-active@3x-en.png" />
                        <img class="img-fluid" v-if="pageName != 'history'" src="@/components/Layout/footer/asset/mass/mass-coupon-inactive@3x-en.png" />
                    </template>
                    <template v-else>
                        <img class="img-fluid" v-if="pageName == 'history'" src="@/components/Layout/footer/asset/mass/mass-coupon-active@3x.png" />
                        <img class="img-fluid" v-if="pageName != 'history'" src="@/components/Layout/footer/asset/mass/mass-coupon-inactive@3x.png" />
                    </template>
                </div>
            </div>
            <div class="aia-tabmenu-item"
                :class="{'aia-tabmenu-item-active': pageName == 'about'}"
                @click="clickMenu('about')">
                <div class="aia-tabmenu-img">
                    <template v-if="localeCode == 1033">
                        <img class="img-fluid" v-if="pageName == 'about'" src="@/components/Layout/footer/asset/mass/mass-about-active@3x-en.png" />
                        <img class="img-fluid" v-if="pageName != 'about'" src="@/components/Layout/footer/asset/mass/mass-about-inactive@3x-en.png" />
                    </template>
                    <template v-else>
                        <img class="img-fluid" v-if="pageName == 'about'" src="@/components/Layout/footer/asset/mass/mass-about-active@3x.png" />
                        <img class="img-fluid" v-if="pageName != 'about'" src="@/components/Layout/footer/asset/mass/mass-about-inactive@3x.png" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// helper
import { TrackingService } from "@/helper/TrackingHelper.js";
import Locale from "@/helper/locale/locale.js";
export default {
    name: 'MassFootMenu',
    props: {
        pageName: String
    },
    data: function () {
        return {
            trackingService: new TrackingService(this),
            localeCode: Locale.getLocaleCode(),
        };
    },
    methods: {
        clickMenu: function(page) {
            this.bzbTracking(page)
            var path = `/${page}`;
            if(page == 'history') path += "/burn"
            this.$router.push(path);
        },
        bzbTracking: function(type) {
            var trackingEventCategory = ''
            var eventName = ''
            switch(type) {
                case 'home':
                    trackingEventCategory = 'homepage_list'
                    eventName = 'click_homepage'
                    break;
                case 'about':
                    trackingEventCategory = 'about_us'
                    eventName = 'click_about_us'
                    break;
            }
            this.trackingService.event(trackingEventCategory, eventName, null, null)
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

#aia_tabmenu {
    background-color: $mass_theme_color;

    #aia_tabmenu_wrapper .aia-tabmenu-item-active {
        background-image: url(../asset/mass/mass-fade-menu@3x.png);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
}
</style>
